export default "__VITE_ASSET__DasYazDo__"